import { useMutation, useQueryClient } from "react-query";
import { useExpensesState } from "atoms/expensesAtom";

import { deleteArticle } from "./index";

export const useDeleteArticle = () => {
  const queryClient = useQueryClient();
  const { setExpensesState } = useExpensesState();

  return useMutation(["delete-article"], deleteArticle, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["get-articles-list"] });
      setExpensesState({ activeItem: null });
    },
  });
};
